<!--
Copyright 2022 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license, please see LICENSE.md in the
project root for license information or contact permission@sei.cmu.edu for full terms.
-->

<div class="cssLayoutRowStartCenter">
  <div class="sp-icon" style="margin-right: 10px;">
    <mat-icon class="mdi-24px" fontIcon="mdi-clipboard-list-outline" [ngStyle]="{'color': 'var(--mat-sys-primary)'}"></mat-icon>
  </div>
  <button mat-icon-button (click)="addOrEditMove(null)" style="outline: none; margin-left: 20px;" title="Add Move"
    [disabled]="!canEdit">
    <mat-icon class="mdi-24px self-center" fontIcon="mdi-plus-circle"></mat-icon>
  </button>
  <mat-form-field class="button-margins search-field">
    <input matInput [formControl]="filterControl" placeholder="Search" />
    @if (filterControl.value) {
    <button mat-icon-button matSuffix (click)="applyFilter('')" title="Clear Search">
      <mat-icon style="transform: scale(0.85)" fontIcon="mdi-close-circle-outline"></mat-icon>
    </button>
    }
  </mat-form-field>
</div>

<mat-accordion displayMode="flat">
  <section matSort (matSortChange)="sortChanged($event)" class="mat-elevation-z2 header-row">
    <div class="header-cell cell-two"></div>
    <div class="header-cell cell-one" mat-sort-header="moveNumber">Number</div>
    <div class="header-cell cell-eight" mat-sort-header="description">Description</div>
  </section>

  @for (move of sortedMoves; track move.id) {
  <mat-expansion-panel [disabled]="true">
    @if (!isLoading) {
    <mat-expansion-panel-header class="row">
      <div class="cell cell-two">
        <button mat-icon-button (click)="addOrEditMove(move); $event.stopPropagation()" style="outline: none;"
          title="Edit Move">
          <mat-icon class="mdi-18px self-center" fontIcon="mdi-square-edit-outline"></mat-icon>
        </button>
        <button mat-icon-button (click)="deleteMoveRequest(move); $event.stopPropagation()" title="Delete Move"
          [disabled]="!canEdit">
          <mat-icon class="mdi-18px" fontIcon="mdi-trash-can-outline"></mat-icon>
        </button>
      </div>
      <div class="cell cell-one center-self">
        {{ move.moveNumber }}
      </div>
      <div class="cell cell-eight center-self">
        {{ move.description }}
      </div>
    </mat-expansion-panel-header>
    }
  </mat-expansion-panel>
  }
</mat-accordion>

@if (isLoading) {
<mat-card appearance="outlined" style="display: flex; justify-content: center; align-items: center;">
  <mat-progress-spinner color="primary" mode="indeterminate">
  </mat-progress-spinner>
</mat-card>
}
